import { BaseNote } from './base-note.dto';
import { Project } from './project.dto';

export class ProjectNote extends BaseNote {
  project?: Project;
}
